let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("23UL7")).then(() => parcelRequire('60PaG'));